export default "__VITE_ASSET__1KIUjxz8__"